import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import config from "../../config";

const CancellationAndRefundPolicy = () => {
    const [loading, setLoading] = useState(true);
    const [content, setContent] = useState("");
    const [error, setError] = useState(null);

    useEffect(() => {
        document.title = `CancellationAndRefundPolicy | Agile Seekers`;
        document.getElementById("bodywrap").className = "carpmain";

        // Define your API URL
        const apiUrl = `${config.API_BASE_URL}/page`;

        // Prepare the request payload
        const requestData = {
            page_name: "refund_policy",
        };

        // Make the POST request
        fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 1) {
                    setContent(data.data.content); // Set the fetched content
                } else {
                    setError("Failed to load content");
                    console.error("Error:", data.message);
                }
                setLoading(false); // Hide loading indicator
            })
            .catch((error) => {
                console.error("Fetch Error:", error);
            });
    }, []);

    return (
        <>
            <Navbar />

            <section>
                <Container>
                    <Row>
                        <Col className="carp-top">
                            <h2>Cancellation and Refund Policy</h2>
                            {/* <h6>Last updated: July 23, 2023</h6> */}
                        </Col>
                    </Row>
                    <Row>
                        {loading && <div>Loading...</div>}
                        {!loading && error && <div>{error}</div>}
                        {!loading && !error && (
                            <Col
                                className="carp-content"
                                dangerouslySetInnerHTML={{ __html: content }}
                            ></Col>
                        )}
                    </Row>
                </Container>
            </section>

            <Footer />
        </>
    );
};
export default CancellationAndRefundPolicy;
